import React from "react"; // Import React

// Add 'type' to the destructured props, default it to "text"
export default function TextInput({ label, placeholder, value, onChange, required, type = "number" }) {
  return (
    <div className="input-wrapper">
      {label && <label style={{display: 'block', marginBottom: '0.25rem', fontSize: '0.85rem', fontWeight: '500'}}>{label}{required ? ' *' : ''}</label>} {/* Added back style from previous example for consistency */}
      <input
        type={type} // Use the 'type' prop here
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        // Add className if needed for styling
        // className="your-input-class"
      />
    </div>
  );
}